"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncMap = void 0;
/**
 * Runs Array.map asyncronously.
 *
 * @param list The array to map
 * @param executor The function to run for each
 */
exports.asyncMap = (list, executor) => __awaiter(void 0, void 0, void 0, function* () {
    return Promise.all(list.map(executor));
});
//# sourceMappingURL=async-map.js.map